import { getDeviceInfo } from './deviceUtils';

const INIT_FLAG = '__wl_vconsole_inited__';

/**
 * 在移动端（手机/平板）展示 vConsole，便于无 Mac 远程调试时看日志与网络。
 *
 * - 开发环境：检测到 mobile / tablet 即自动加载（动态 import，桌面 dev 不打包进首屏）。
 * - 任意环境：`.env` 设置 `REACT_APP_ENABLE_VCONSOLE=1` 则强制开启（用于生产包真机联调）。
 */
export function initVConsoleIfNeeded(): void {
  if (typeof window === 'undefined') {
    return;
  }
  if ((window as unknown as Record<string, boolean>)[INIT_FLAG]) {
    return;
  }

  const envFlag = process.env.REACT_APP_ENABLE_VCONSOLE?.trim().toLowerCase();
  const forceOn = envFlag === '1' || envFlag === 'true' || envFlag === 'yes';

  let devMobile = false;
  if (process.env.NODE_ENV === 'development') {
    const { isMobile, isTablet } = getDeviceInfo();
    devMobile = isMobile || isTablet;
  }

  if (!forceOn && !devMobile) {
    return;
  }

  void import('vconsole').then(({ default: VConsole }) => {
    if ((window as unknown as Record<string, boolean>)[INIT_FLAG]) {
      return;
    }
    (window as unknown as Record<string, boolean>)[INIT_FLAG] = true;
    new VConsole({ theme: 'dark' });
  });
}
